<template>
<div>
    <h3>Диалоги</h3>
    <div v-for="dialogue of dialogues" :key="dialogue._id">
        <DialogueCard :dialogue="dialogue"/>
    </div>
</div>
</template>

<style scoped>
a{
    color:#404040;
}
</style>

<script>
import DialogueCard from '@/components/profile/DialogueCard.vue'

export default {
    components: { DialogueCard },
    data(){
        return {
            dialogues:[]
        }
    },
    async created(){
        this.dialogues = (await this.$axios.get('/chat/dialogues')).data
    }
}
</script>